__turbopack_context__.v({
  "connectCard": "ContactPage-module-scss-module__6fNIxG__connectCard",
  "connectReveal": "ContactPage-module-scss-module__6fNIxG__connectReveal",
  "contactForm": "ContactPage-module-scss-module__6fNIxG__contactForm",
  "contactShell": "ContactPage-module-scss-module__6fNIxG__contactShell",
  "content": "ContactPage-module-scss-module__6fNIxG__content",
  "description": "ContactPage-module-scss-module__6fNIxG__description",
  "drift": "ContactPage-module-scss-module__6fNIxG__drift",
  "float": "ContactPage-module-scss-module__6fNIxG__float",
  "formReveal": "ContactPage-module-scss-module__6fNIxG__formReveal",
  "header": "ContactPage-module-scss-module__6fNIxG__header",
  "profileBlock": "ContactPage-module-scss-module__6fNIxG__profileBlock",
  "profileCopy": "ContactPage-module-scss-module__6fNIxG__profileCopy",
  "profileImage": "ContactPage-module-scss-module__6fNIxG__profileImage",
});
